module.exports = "/_next/static/images/SignupGpPortfolioPilot-62faaedea83a155140763c02102a0a17.svg";